<ng-container
  *ngIf="isLoadingAttributeDescriptions$ | async; else newsDetailsTemplate"
>
  <div class="d-flex justify-content-center align-items-center min-vh-70">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</ng-container>
<ng-template #newsDetailsTemplate>
  <div class="news-details">
    <ng-container *ngIf="canViewDetails(); else noDetailsTemplate">
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn p-0 mr-2 text-gray"
          aria-label="Back button"
          (click)="goBack()"
        >
          <i class="fas fa-arrow-left"></i>
        </button>
        <span class="mr-3 text-gray">{{ 'News' | translate }}</span>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
        <div class="d-flex align-items-center">
          <div
            class="sender-profile d-flex justify-content-center mr-3"
            *ngIf="details?.from?.image"
          >
            <div class="rounded-circle">
              <a
                class="d-inline-block jip-upper-first-letter font-weight-bold"
                [href]="peopleURL + '/' + details?.from.id"
              >
                <img
                  alt="profile image"
                  [src]="details?.from?.image"
                  appDefaultAvatar
                  appDynamicImgUrl
                />
              </a>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <span
              class="underline d-inline-block jip-upper-first-letter font-weight-bold"
            >
              {{ getSender() }}
            </span>

            <span class="divider d-flex align-items-center">|</span>

            <ng-container *ngIf="showDate">
              <span class="d-inline-block text-medium-gray">
                {{
                  details?.dateTime
                    | localizedDate : DateFormat.FullDateTimeCommon4
                }}
              </span>
            </ng-container>
          </div>

          <span class="divider d-flex align-items-center">|</span>

          <button
            type="button"
            class="btn btn-link p-0 text-gray-500 btn-copy-link"
            [ngbTooltip]="
              copied
                ? ('UI.Common.Copied' | translate)
                : ('UI.Common.Copy' | translate)
            "
            (click)="copyPostLink()"
          >
            <i class="far fa-copy"></i>
            <span class="ml-1">
              {{
                copied
                  ? ('UI.Common.Copied' | translate)
                  : ('UI.Common.Copy' | translate)
              }}
            </span>
          </button>
        </div>

        <div class="text-right" *ngIf="details?.content?.category">
          <span class="font-weight-bold">Category:</span>
          <span class="text-medium-gray ml-1"
            >Switzerland, AI Trusted Partner</span
          >
        </div>
      </div>

      <div class="news-details__content">
        <div *ngIf="details?.message" class="news-details__content">
          <span [innerHTML]="rawHtml"></span>
          <hr class="d-inline-block" />
        </div>

        <div class="text-medium-gray" *ngIf="streams && streamNames">
          <span class="flex-shrink-0 font-weight-bold" translate
            >UI.PublishingStreams.Label</span
          >
          :
          <span class="stream-items">{{ streamNames }}</span>
        </div>
      </div>
    </ng-container>

    <ng-template #noDetailsTemplate>
      <button
        type="button"
        appRequireLogin
        class="rich-text-toggle__btn-link btn-link-primary restrict-content"
      >
        <span>
          {{ 'UI.Common.LoginToViewDetails' | translate }}
        </span>
      </button>
    </ng-template>
  </div>
</ng-template>
